import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import { AutorevolWizardResponse } from '../models/Autorevol/AutorevolWizardResponse';

export class AutorevolWizardControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) { }

    /**
     * @returns string OK 
     * @throws ApiError
     */
    public postInterview(sessionId: string | null, answerRequest: string[] = []): CancelablePromise<AutorevolWizardResponse> {
        const url = sessionId ? `/vehicles/autorevol/interview/${sessionId}` : '/vehicles/autorevol/interview'
        return this.httpRequest.request({
            url,
            method: 'POST',
            body: { answer: answerRequest },
            mediaType: 'application/json',
        });
    }

}
